<app-ds-autocomplete
	[label]="label"
	[placeholder]="placeholder"
	[hint]="hint"
	[required]="required"
	[disabled]="disabled"
	[options]="tiposRiesgoSocial"
	[displayWith]="displayTipoRiesgoSocial"
	[value]="selectedTipoRiesgoSocial"
	(valueChange)="onValueChange($event)"
	(touched)="onControlTouched()"
></app-ds-autocomplete>
